import { 
    useBlockProps,
	InnerBlocks,
} from '@wordpress/block-editor';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {Element} Element to render.
 */
export default function save(props) {
	const {attributes} = props;

	return (
		<div data-scroll-effect={attributes.enableParallaxScroll} data-mouse-effect={attributes.enableMouseEffect} data-speed={attributes.parallaxScrollSpeed} { ...useBlockProps.save({className: `wpopus-parallax-bg-cover`}) }>
			<InnerBlocks.Content />
		</div>
	);
}
